import Backbone from 'backbone'
import Slide from './slide'

var Slides = Backbone.Collection.extend({
	model: Slide,
	section: 'briefings'
})

export default Slides

Slides.__filename__ = 'briefings/slides.js'
